module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.loadedPages === 0 ? 'Подробно' : 'Кратко ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded) && this.count > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_c('div', [_vm._v("\n        Прав требования открыто "), _c('b', [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), (this.sumAmount != null) ? _c('div', [_vm._v("\n            Сумма прав требования \n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumAmount))
    }
  })])]) : _vm._e(), _vm._v(" "), (this.sumRemaining != null) ? _c('div', [_vm._v("\n            Сумма текущих прав требования \n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumRemaining))
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading || this.items.length > 0) ? _c('v-panel-text', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchText()
      }
    }
  }, [_c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.enforcementNumber) + " ")]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.institutionDate, _vm.formats.formatDate)) + "\n            ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n            Должник: "), (item.debtorRef) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.debtorRef, '_blank'))
      }
    }) : _vm._e(), _vm._v(" "), (!item.debtorRef) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.debtorRef) ? _c(_vm.renderFlags(item.debtorRef.flags, true), {
      tag: "v-component"
    }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v("Права требования")]), _vm._v(" были/сейчас: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.amount))
      }
    }), _vm._v("/"), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.remaining))
      }
    })]), _vm._v(" - " + _vm._s(item.executionObject) + ".\n            ")])])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e77c648","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/EnforcementsPanel.vue
// module id = 1054
// module chunks = 1